import React,{useEffect,useState} from 'react';
import { useCookies } from 'react-cookie';
import { GoogleLogin,useGoogleLogin } from '@react-oauth/google';
import '../App.css';


const Header=()=>{

const [cookies, setCookie,removeCookie] = useCookies(['user_FirstName','user_LastName','user_Email','user_Phone','user_Zip']);
const loggedIn=false;

useEffect(()=>{

  document.getElementById('profileFirstName').value=cookies.user_FirstName;
  document.getElementById('profileLastName').value=cookies.user_LastName;
  document.getElementById('profileEmail').value=cookies.user_Email;
  document.getElementById('profilePassword').value="";
  document.getElementById('profileConfirm').value="";
  document.getElementById('profilePhone').value=cookies.user_Phone;
  document.getElementById('profileZip').value=cookies.user_Zip;

})

const showInitials=()=>{
  if(cookies.user_FirstName && cookies.user_LastName){
    return cookies.user_FirstName.substr(0,1).toUpperCase()+""+cookies.user_LastName.substr(0,1).toUpperCase();
  }
}
const googleLogin = useGoogleLogin({
  onSuccess: tokenResponse => {
    let access_token=tokenResponse.access_token;
    console.log(tokenResponse.access_token)
    getGoogleUserInfo(access_token);
  },  
});
const getGoogleUserInfo=async (access_token)=>{


  let res = await fetch("https://api.hudhousingnetwork.com/1/google_signin", {
    method: "POST",
    headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      hash: access_token,
    }),
  });

  res.json().then(data=>{    
    
    console.log(data);
    if(data.success==0){
      document.querySelector(".alertMessageSignup").innerHTML=data.errMsg+"";
      document.querySelector(".alertMessageSignin").innerHTML=data.errMsg+"";
      return;
    }

    setCookie('user_FirstName', data.firstname, { path: '/' });
    setCookie('user_LastName', data.lastname, { path: '/' });
    setCookie('user_Email', data.email, { path: '/' });
    setCookie('user_Phone', data.phone, { path: '/' });
    setCookie('user_Zip', data.zip, { path: '/' });
    setCookie('user_pic', data.pic, { path: '/' });

    showInitials();

    closeSignupPopups();


  });

}
const doSignout=()=>{
  removeCookie('user_FirstName',{path:'/'});
  removeCookie('user_LastName',{path:'/'});
  removeCookie('user_Email',{path:'/'});
  removeCookie('user_Phone',{path:'/'});
  removeCookie('user_Zip',{path:'/'});
  hideSignUpInMenu();
}
const resetSignUpIn=()=>{
  document.querySelector(".alertMessageSignup").innerHTML="";
  document.querySelector('#signup-step2').style.display='none';
  document.querySelector('#signup-step1').style.display='block';
  document.querySelector('#signupGoogle').style.display='block';  
}
const nextSignupStep=()=>{

  var firstName=document.getElementById('signupFirstName').value.trim();
  var lastName=document.getElementById('signupLastName').value.trim();
  var email=document.getElementById('signupEmail').value.trim();
  var phone=document.getElementById('signupPhone').value.trim();
  var zip=document.getElementById('signupZip').value.trim();

  if(firstName=="" || lastName=="" || email=="" || phone=="" || zip==""){
    document.querySelector(".alertMessageSignup").innerHTML="All fields are required!";
    return;
  }
  document.querySelector(".alertMessageSignup").innerHTML="";


  document.querySelector('#signup-step1').style.display='none';
  document.querySelector('#signup-step2').style.display='block';
  document.querySelector('#signupGoogle').style.display='none';
}

const doProfileUpdate=async ()=>{
  var firstName=document.getElementById('profileFirstName').value.trim();
  var lastName=document.getElementById('profileLastName').value.trim();
  var email=document.getElementById('profileEmail').value.trim();
  var password=document.getElementById('profilePassword').value.trim();
  var confirm=document.getElementById('profileConfirm').value.trim();
  var phone=document.getElementById('profilePhone').value.trim();
  var zip=document.getElementById('profileZip').value.trim();

  if( password!=confirm ){
    if(password!="" || confirm!=""){
      document.querySelector(".alertMessageProfile").innerHTML="Password and confirm password should be same.";
      return;
    }
  }

  

  if(firstName=="" || lastName=="" || email=="" || phone=="" || zip==""){
    document.querySelector(".alertMessageProfile").innerHTML="All fields are required!";
    return;
  }


  let res = await fetch("https://api.hudhousingnetwork.com/1/profile-update", {
    method: "POST",
    headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      firstname: firstName,
      lastname: lastName,
      email: email,
      password: password,
      phone: phone,
      zip: zip,
    }),
  });

  res.json().then(data=>{
    console.log(data);
    if(data.success==0){
      document.querySelector(".alertMessageProfile").innerHTML=data.errMsg+"";
      return;
    }

    setCookie('user_FirstName', firstName, { path: '/' });
    setCookie('user_LastName', lastName, { path: '/' });
    setCookie('user_Email', email, { path: '/' });
    setCookie('user_Phone', phone, { path: '/' });
    setCookie('user_Zip', zip, { path: '/' });
    closeSignupPopups();

  });
  

}

const doSignup=async ()=>{
  var firstName=document.getElementById('signupFirstName').value.trim();
  var lastName=document.getElementById('signupLastName').value.trim();
  var email=document.getElementById('signupEmail').value.trim();
  var password=document.getElementById('signupPassword').value.trim();
  var phone=document.getElementById('signupPhone').value.trim();
  var zip=document.getElementById('signupZip').value.trim();

  if(firstName=="" || lastName=="" || email=="" || password=="" || phone=="" || zip==""){
    document.querySelector(".alertMessageSignup").innerHTML="Password field is required!";
    return;
  }


  let res = await fetch("https://api.hudhousingnetwork.com/1/signup", {
    method: "POST",
    headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      firstname: firstName,
      lastname: lastName,
      email: email,
      password: password,
      phone: phone,
      zip: zip,
    }),
  });

  res.json().then(data=>{
    console.log(data);
    if(data.success==0){
      document.querySelector(".alertMessageSignup").innerHTML=data.errMsg+"";
      return;
    }

    setCookie('user_FirstName', firstName, { path: '/' });
    setCookie('user_LastName', lastName, { path: '/' });
    setCookie('user_Email', email, { path: '/' });
    setCookie('user_Phone', phone, { path: '/' });
    setCookie('user_Zip', zip, { path: '/' });
    closeSignupPopups();

  });
  

}

const doSignin=async ()=>{
  var email=document.getElementById('signinEmail').value.trim();
  var password=document.getElementById('signinPassword').value.trim();

  if(email=="" || password==""){
    document.querySelector(".alertMessageSignin").innerHTML="All fields are required!";
    return;
  }


  let res = await fetch("https://api.hudhousingnetwork.com/1/signin", {
    method: "POST",
    headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: email,
      password: password,
    }),
  });
  res.json().then(data=>{
    console.log(data);
    if(data.success==0){
      document.querySelector(".alertMessageSignin").innerHTML="Invalid email or password!";
      return;
    }

    setCookie('user_FirstName', data.firstname, { path: '/' });
    setCookie('user_LastName', data.lastname, { path: '/' });
    setCookie('user_Email', data.email, { path: '/' });
    setCookie('user_Phone', data.phone, { path: '/' });
    setCookie('user_Zip', data.zip, { path: '/' });
    closeSignupPopups();


  });
  

}

const showSignUpMenu=()=>{
  if(document.querySelector(".signupMenu").style.display=='none')
    document.querySelector(".signupMenu").style.display='block';
  else
    hideSignUpInMenu();
}
const hideSignUpInMenu=()=>{
  document.querySelector(".signinMenu").style.display='none';
}

const showSignInMenu=()=>{
  if(document.querySelector(".signinMenu").style.display=='none')
    document.querySelector(".signinMenu").style.display='block';
  else
    hideSignUpInMenu();
}
const profileButton=()=>{
  resetSignUpIn();
  var profile=document.querySelector(".profile-popup");
  var overlay=document.querySelector(".popup-overlay");
  profile.style.display='block';
  overlay.style.display='block';

}
const SignupButton=()=>{
  resetSignUpIn();
  var signup=document.querySelector(".signup-popup");
  var overlay=document.querySelector(".popup-overlay");
  signup.style.display='block';
  overlay.style.display='block';
}

const closeSignupPopups=()=>{
  var signup=document.querySelector(".signup-popup");
  var signin=document.querySelector(".signin-popup");
  var profile=document.querySelector(".profile-popup");
  var overlay=document.querySelector(".popup-overlay");
  signup.style.display='none';
  signin.style.display='none';
  profile.style.display='none';
  overlay.style.display='none';
  document.querySelector(".alertMessageSignup").innerHTML="";
  document.querySelector(".alertMessageSignin").innerHTML="";
  document.querySelector(".alertMessageProfile").innerHTML="";
  hideSignUpInMenu();
}

const SigninButton=()=>{
  var signin=document.querySelector(".signin-popup");
  var overlay=document.querySelector(".popup-overlay");
  signin.style.display='block';
  overlay.style.display='block';
}


const toggleMenu=()=>{
      var x = document.getElementById("menu-ul");
        if (x.style.display === "none") {
          x.style.display = "block";
        } else {
          x.style.display = "none";
        }
    }

  return (

<>
<header>
<div>
    <div className="popup-overlay" style={{display:'none'}}></div>
    <div className="signup_wrapper signup-popup" style={{display:'none'}}>
      <div className="closebutton"><img src="/img/closebutton.png" onClick={()=>{closeSignupPopups();}} /></div>
      <h2 className="top-heading">Signup To Get Access</h2>
      <p>Receive Waiting List Updates, New Property Listings, Real-Time Alerts and More</p>
      <div className="alertMessageSignup"></div>
      <div className="signup-form">
        
        <div id="signup-step1">
          <div style={{display:'flex',width:'94%',margin:'0 auto'}}>
            <div><input id="signupFirstName" type="text" placeholder="First Name" /></div>
            <div><input id="signupLastName" type="text" placeholder="Last Name" /></div>
          </div>        
          <input id="signupEmail" type="text" placeholder="Email" />
          <input id="signupPhone" type="text" placeholder="Phone" />
          <input id="signupZip" type="text" placeholder="Zipcode" />
          <button className="signup-btn" onClick={()=>{nextSignupStep()}}>Become A Member</button>
        </div>
        <div id="signup-step2" style={{display:'none'}}>
          <input id="signupPassword" type="password" placeholder="Password" />
          <button className="signup-btn" onClick={()=>{doSignup()}}>Signup</button>
          <div style={{marginTop:10}}><a style={{color:'#4f93e1'}} href="javascript:void(0);" onClick={()=>{resetSignUpIn()}} >back</a></div>

        </div>

        <div id="signupGoogle">
          <span>Or</span>
          <button className="signup-with-google-btn" onClick={()=>googleLogin()}><img src="/img/google-icon.png" />Signup with Google</button>
        </div>

      </div>
    </div>
    <div className="signup_wrapper signin-popup" style={{display:'none'}}>
      <div className="closebutton"><img src="/img/closebutton.png" onClick={()=>{closeSignupPopups();}} /></div>
      <h2 className="top-heading">Signin To Get Access</h2>
      <p>&nbsp;</p>
      <div className="alertMessageSignin"></div>
      <div className="signin-form">        
        <input id="signinEmail" type="text" placeholder="Email" />
        <input id="signinPassword" type="password" placeholder="Password" />
        <button className="signup-btn" onClick={()=>{doSignin()}}>Sign In</button><br /> 
        <button className="signup-with-google-btn" onClick={()=>googleLogin()} style={{marginTop:5}}><img src="/img/google-icon.png" />Signin with Google</button>
        <br />&nbsp;
      </div>
    </div>
    <div className="signup_wrapper profile-popup" style={{display:'none'}}>
      <div className="closebutton"><img src="/img/closebutton.png" onClick={()=>{closeSignupPopups();}} /></div>
      <h2 className="top-heading">Profile</h2>
      <div className="alertMessageProfile"></div>
      <div className="signup-form">
        
        <div style={{display:'flex',width:'94%',margin:'0 auto'}}>
          <div><input id="profileFirstName" type="text" placeholder="First Name" /></div>
          <div><input id="profileLastName" type="text" placeholder="Last Name"  /></div>
        </div>        
        <input id="profileEmail" type="text" placeholder="Email"  />
        <input id="profilePhone" type="text" placeholder="Phone"  />
        <input id="profileZip" type="text" placeholder="Zipcode"  />        
        <input id="profilePassword" type="password" placeholder="Password" />
        <input id="profileConfirm" type="password" placeholder="Confirm Password" />
        <button className="signup-btn" onClick={()=>{doProfileUpdate()}}>Update</button>

      </div>
    </div>
    <a className="logo" href="/"><img src="/img/logo.png" alt="" /></a>
    <a className="logo-mobile" href="/"><img src="/img/logo-mobile.png" alt="" /></a> 
    <div className="nav">
      <span onClick={()=>toggleMenu()} ><img src="/img/menu.png" /></span>
      <ul id="menu-ul" style={{display:'none'}}>
        <li><a href="/public-housing-waiting-lists">Public Housing Waiting Lists</a></li>
        <li><a href="/section-8-waiting-lists">Section 8 Waiting Lists</a></li>
        <li><a href="/emergency-rental-assistance">Emergency Rental Assistance</a></li>
        <li><a href="/community-action-center">Community Action Center</a></li>
        <li><a href="/blog/">Blog</a></li>     
      </ul>
    </div>
    <div className="logged-person">{(cookies.user_FirstName && cookies.user_LastName) ? (<span onClick={()=>{showSignInMenu()}} className="loginText"><div style={{width:20,height:20,background:'#f34848', borderRadius:10,color:'#fff',lineHeight:'20px',fontSize:14,fontWeight:'bold',position:'absolute',display:'none'}}>!</div>{showInitials()}</span>) : (<span className="logoutText"><a href="javascript:void(0); " onClick={()=>{SignupButton();}} >Sign Up</a> <span style={{color:'#bbb',fontSize:14}}> | </span><a href="javascript:void(0);" onClick={()=>{SigninButton();}} >Signin</a></span>)}
        <div className="signinMenu" style={{display:'none'}}>
          <ul>            
            <li><a href="javascript:void(0)" onClick={()=>{profileButton()}}>Profile</a></li>
            <li><a href="javascript:void(0)" onClick={()=>{doSignout()}}>Logout</a></li>
          </ul>
        </div>
      </div>      
</div>   
{/*}
<div className="mobile-search-bar">
  <input type="text" placeholder="Search by city" />
  <button>Search</button>
</div>
{*/}
  <div style={{clear:'both'}}></div>
</header>
</>
  );
}

export default Header;
